module.exports = __webpack_public_path__ + "img/app-store-black-badge.8c15379d.svg";